import React, { Component } from 'react';
import MaterialTable from 'material-table';
import AutorenewIcon from '@material-ui/icons/Autorenew';

export class MissionTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //projectList: [{ name: 'Proje 1', id: 1 }, { name: 'Proje 2', id: 2 }],
            missionList: [],
        };
    }

    componentDidMount = async () => {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        if (this.props.match.params.projectid === undefined ||
            this.props.match.params.projectid === 0) {
            let pageData = { operation: "GetListOfAllMissions" };

            await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFALLMISSIONS, {
                method: "POST",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authtoken"),
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(pageData)
            })
                .then(response => response.json())
                .then(result => {
                    console.log(result);

                    //this.setState({ projectList: result.projects });
                    this.setState({ missionList: result.missions });
                });
        } else {
            let pageData = {
                operation: "GetListOfMissions",
                selectedprojectid: this.props.match.params.projectid
            };

            await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFMISSIONS, {
                method: "POST",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("authtoken"),
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(pageData)
            })
                .then(response => response.json())
                .then(result => {
                    console.log(result);

                    //this.setState({ projectList: result.projects });
                    this.setState({ missionList: result.missions });
                });
        }
    };

    render() {
        return (
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    columns={[
                        { title: 'Mission Id', field: 'idMissionDetails', hidden: true },
                        { title: 'Mission Number', field: 'MissionNumber' },
                        { title: 'Field Phase Start Date', field: 'FieldPhaseStartDate' },
                        { title: 'Field Phase End Date', field: 'FieldPhaseEndDate' },
                    ]}
                    data={this.state.missionList}
                    title="Missions"
                    actions={[
                        //{
                        //    icon: 'info',
                        //    tooltip: 'Project Details',
                        //    onClick: (event, rowData) => {
                        //        this.props.history.push(`/projectdetails/${rowData.idProjectDetails}`);
                        //    },
                        //},
                        {
                            icon: 'launch',
                            tooltip: 'Mission Details',
                            onClick: (event, rowData) => {
                                this.props.history.push(`/missiondetails/${rowData.idMissionDetails}`);
                            },
                        },
                        {
                            icon: 'flip_camera_android',
                            tooltip: 'Project Monitoring',
                            onClick: (event, rowData) => {
                                this.props.history.push(`/cycleofthereport/${rowData.idMissionDetails}`);
                            },
                        },
                    ]}
                    options={{
                        actionsColumnIndex: -1,
                        pageSize: 20
                    }}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/MissionTable.js